// 🔧 store_seeder.js
// ✅ Purpose: Seeds Event Merch Store demo data into Firestore
// ✅ Features:
// - Coordinates persistence of store products and variants
// - Calls repository layer only
// - No Firestore logic here
// - Returns standardized results to Builder
// - Fully block-commented for clarity and future devs

import { saveStoreProducts } from "./store_repository";

export const seedStore = async ({
  demoContext,
  storePlan,
} = {}) => {
  console.log("🌱 Store Seeder started.");

  if (!storePlan) {
    throw new Error("Store Seeder requires storePlan.");
  }

  const results = await saveStoreProducts({
    demoContext,
    products: storePlan.products || [],
    variants: storePlan.variants || [],
  });

  console.log("✅ Store Seeder completed.", {
    products: results.products.length,
    variants: results.variants.length,
  });

  return results;
};